export default {
  getFormSignature: (state) => state.formSignature,
};
